/** Matches API `FacilityOperationDetailApiModel` / `RegFacilityOperation` JSON (camelCase). */
export interface IFacilityOperationDetail {
    id: string;
    code?: string | null;
    description: string;
    isActive: boolean;
    isDeleted: boolean;
    source: string;
    sourceVersion: string;
    effectiveFromUtc: string;
    createdAtUtc: string;
    updatedAtUtc: string;
    createdByDisplayName?: string | null;
    lastUpdatedByDisplayName?: string | null;
    deletedAuditAtUtc?: string | null;
    deletedByDisplayName?: string | null;
    disabledAuditAtUtc?: string | null;
    disabledByDisplayName?: string | null;
}

export type FacilityOperationCreatePayload = {
    code?: string | null;
    description: string;
    isActive?: boolean;
};

export type FacilityOperationUpdatePayload = {
    id: string;
    code?: string | null;
    description: string;
};

export const FACILITY_OPERATION_CREATE_CONFLICT = {
    deletedRestoreAvailable: "facilityOperation.deletedRestoreAvailable",
    duplicateActive: "facilityOperation.duplicateActive",
} as const;
